import type {Values} from '@wix/devzai-utils-common';

/** Route path for the headless auth start page. */
export const DoppeViewerHeadlessAuthStartPath = '/__auth_start';

/** Route path for the headless auth callback page. */
export const DoppeViewerHeadlessAuthCallbackPath = '/__auth_callback';

/** Session storage key for OAuth data during the auth flow. */
export const DoppeViewerHeadlessOAuthDataSessionKey = 'doppe-headless-oauth-data';

/** PostMessage type used by the auth callback page to notify the opener. */
export const DoppeViewerHeadlessAuthMessageType = 'doppe-headless-auth-callback';

/** Cookie name for storing headless tokens — must match SupportedCookieNames.HeadlessTokens. */
export const DoppeViewerHeadlessTokensCookieName = 'headlessTokens';

/** Login mode for headless authentication. */
export const DoppeHeadlessLoginMode = {
    /** Same-tab redirect: user is redirected away, then back to the original page. */
    Redirect: 'Redirect',
    /** New-tab popup: a popup window handles auth and posts back to the opener. */
    Popup: 'Popup',
} as const;

export type DoppeHeadlessLoginMode = Values<typeof DoppeHeadlessLoginMode>;

/** Shape of the postMessage sent from the auth callback page to the opener. */
export interface DoppeViewerHeadlessAuthCallbackMessage {
    type: typeof DoppeViewerHeadlessAuthMessageType;
    code: string | null;
    state: string | null;
    error?: string;
}
